import React from 'react';
import { PropTypes } from 'prop-types';

import AlertDialog from '../../AlertDialog';

const DeleteInvoiceModal = ({
  confirmHandler, dismissHandler, modal: { item, open },
}) => {
  const modalConfirmHandler = () => {
    confirmHandler(item)();
  };

  const modalDismissHandler = () => {
    dismissHandler();
  };

  return (
    <AlertDialog
      title="Delete Invoice Number"
      open={!!open}
      confirmTitle="Delete"
      onConfirmation={modalConfirmHandler}
      onDismiss={modalDismissHandler}
    >
      {'Are you sure you want to delete the invoice number?'}
    </AlertDialog>
  );
};

DeleteInvoiceModal.propTypes = {
  modal: PropTypes.shape({
    open: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
};

export default DeleteInvoiceModal;
